import React, { createContext, useContext, useState, useEffect } from 'react';
import { cartManager } from '../utils/cartManager';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    // Load cart on mount
    const loadedCart = cartManager.getCart();
    setCart(loadedCart);
    setCartCount(cartManager.getCartCount());
  }, []);

  const addToCart = (item) => {
    const updatedCart = cartManager.addItem(item);
    setCart(updatedCart);
    setCartCount(cartManager.getCartCount());
  };

  const removeFromCart = (size) => {
    const updatedCart = cartManager.removeItem(size);
    setCart(updatedCart);
    setCartCount(cartManager.getCartCount());
  };

  const updateQuantity = (size, quantity) => {
    const updatedCart = cartManager.updateQuantity(size, quantity);
    setCart(updatedCart);
    setCartCount(cartManager.getCartCount());
  };

  const clearCart = () => {
    const updatedCart = cartManager.clearCart();
    setCart(updatedCart);
    setCartCount(0);
  };

  const getTotal = () => {
    return cartManager.getCartTotal();
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        cartCount,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        getTotal
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
